/* eslint-disable */
import BaseRequest from './BaseRequest';
import Apis from './Apis';
import Auth from './Auth';
import DataCenterLog from './DataCenterLog';
import ApiDomain from './ApiDomain';
import Debugger from '../common/js/Debugger';
import qs from 'qs';

class QuRequest extends BaseRequest {
  constructor() {
    super();
    this.Apis = Apis;
    this.apiDomain = new ApiDomain();
  }

  getUrl(api) {
    return this.apiDomain.getUrl(api);
  }

  nativeSend(api, data = {}) {
    data = Object.assign(
      {
        token: Auth.getToken(),
        dtu: 200,
      },
      data,
    );

    if (api.project === 'perm') {
      data.project = 'perm';
    }
    Debugger.save(api.url, api.type, qs.stringify(data));

    return super
      .send(
        {
          url: api.url,
          type: api.type,
          timeout: api.timeout,
          headers: api.headers,
        },
        data,
      )
      .then(
        response => {
          let res = response.data;
          if (
            res.code == 0 ||
            res.code == -2101 ||
            res.code == 10017 ||
            res.code == 10007
          ) {
            return res;
          } else if (res.code == -126) {
            // 清除登录状态，避免登录状态失效后死循环问题
            Auth.setToken('');
            // setTimeout(() => {
            //   location.href = '/';
            // }, 2000);
            throw new Error('登陆状态失效, 请登陆');
          } else {
            // it 's joke
            let message = res.message.replace(
              /(周海龙|zhouhailong|曹龙龙|caolonglong|徐茹|xuru|胡配方|hupeifang)/gi,
              '聂元培',
            );
            DataCenterLog.send({
              item: 2001,
              path: api.url,
              author: api.author,
              code: res.code,
              message: message,
            });
            // TODO 想法：实现一个 ApiStack 类，负责在展示详细的错误日志( request, response, api, stack... )
            throw {
              message: `请求失败code: ${res.code}, message: ${message ||
                '未知原因'}，接口开发者：${api.author}`,
              stack: new Error().stack,
              code: res.code,
            };
          }
        },
        error => {
          let status = 0;
          if (error.response) {
            status = error.response.status;
          } else if (error.request) {
            status = error.request.status;
          }
          throw new Error(`网络错误[${status}](${api.url}):${error.message}`);
        },
      );
  }

  send(api, data = {}) {
    let url = this.apiDomain.getUrl(api);
    return this.nativeSend(
      {
        url: url,
        type: api.type,
        timeout: api.timeout,
        headers: api.headers,
        author: api._author || '',
        project: data.project || api.project,
      },
      data,
    );
  }

  export(api, data = {}) {
    data = Object.assign(
      {
        token: Auth.getToken(),
        dtu: 200,
      },
      data,
    );
    let params = qs.stringify(data);
    let url = this.apiDomain.getUrl(api);
    url = url + '?' + params;
    window.open(url, '_blank');
  }

  jsonp(url) {
    if (!url) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.cb = result => {
        resolve(result);
      };
      let JSONP = document.createElement('script');
      JSONP.type = 'text/javascript';
      JSONP.src = `${url}`;
      JSONP.onerror = function() {
        reject();
      };
      document.getElementsByTagName('head')[0].appendChild(JSONP);
      setTimeout(() => {
        document.getElementsByTagName('head')[0].removeChild(JSONP);
      }, 500);
    });
  }

  getBranch() {
    return this.apiDomain.getBranchMap();
  }

  isProduct() {
    return this.apiDomain.isProduct();
  }
}

export default QuRequest;



// WEBPACK FOOTER //
// ./src/core/QuRequest.js